/* Dress To | Black Friday 2026 page: countdown and date-based content.
   Phases: pre (before early access), early (early access), live (stage 1), peak (stage 2), ended.
   The phase is set on <html data-bf26-phase> (first by a small inline script in the hero, then here every
   second), and black-friday.css hides elements whose data-bf26-when="pre early ..." doesn't include it.
   QA: add ?bf26_now=2026-11-25T10:00:00-05:00 to the URL to preview the page at another time. */
(function () {
  if (window.__bf26) return;
  window.__bf26 = true;

  var qa = null;
  try {
    var q = new URLSearchParams(location.search).get('bf26_now');
    if (q && !isNaN(Date.parse(q))) qa = Date.parse(q) - Date.now();
  } catch (e) {}
  function now() { return Date.now() + (qa || 0); }
  function parse(s) { if (!s) return null; var t = Date.parse(s); return isNaN(t) ? null : t; }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function phaseOf(t, early, start, peak, end) {
    if (end && t >= end) return 'ended';
    if (peak && t >= peak) return 'peak';
    if (start && t >= start) return 'live';
    if (early && t >= early) return 'early';
    return 'pre';
  }

  function applyPhase(phase) {
    var root = document.documentElement;
    if (root.getAttribute('data-bf26-phase') !== phase) root.setAttribute('data-bf26-phase', phase);
  }

  function render(el) {
    var d = el.dataset;
    var early = parse(d.earlyStart), start = parse(d.start), peak = parse(d.peakStart), end = parse(d.end);
    if (!start) { el.hidden = true; return false; }
    var t = now(), phase = phaseOf(t, early, start, peak, end);
    applyPhase(phase);
    var target = null, text = '';
    if (phase === 'pre') { target = early || start; text = early ? d.labelPreEarly : d.labelPre; }
    else if (phase === 'early') { target = start; text = d.labelEarly; }
    else if (phase === 'live') { target = peak || end; text = peak ? d.labelLive : d.labelPeak; }
    else if (phase === 'peak') { target = end; text = d.labelPeak; }
    else { text = d.labelEnded; }
    var label = el.querySelector('[data-bf26-label]');
    if (label && label.textContent !== (text || '')) label.textContent = text || '';
    el.classList.toggle('is-over', !target);
    if (!target) return false;
    var left = Math.max(0, Math.floor((target - t) / 1000));
    var parts = { d: Math.floor(left / 86400), h: Math.floor(left % 86400 / 3600), m: Math.floor(left % 3600 / 60), s: left % 60 };
    for (var k in parts) {
      var n = el.querySelector('[data-bf26-' + k + ']');
      if (n) n.textContent = k === 'd' ? String(parts[k]) : pad(parts[k]);
    }
    return true;
  }

  var gen = 0;
  function start() {
    var clocks = document.querySelectorAll('[data-bf26-clock]');
    if (!clocks.length) return;
    var mine = ++gen;
    var tick = function () {
      if (mine !== gen) return;
      var running = false;
      for (var i = 0; i < clocks.length; i++) running = render(clocks[i]) || running;
      if (running) setTimeout(tick, 1000 - (now() % 1000) + 10);
    };
    tick();
  }

  /* Buttons that point to a section of this page (e.g. "Join the VIP list" -> #vip) scroll to it,
     also on theme preview links and translated URLs, where the full page path would reload the page. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.bf26 a[href*="#"]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    var id = decodeURIComponent(url.hash.slice(1));
    var target = id && document.getElementById(id);
    var last = function (p) { return p.replace(/\/+$/, '').split('/').pop(); };
    if (!target || url.origin !== location.origin || last(url.pathname) !== last(location.pathname)) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    var heading = target.querySelector('h2') || target;
    if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* Re-run when the section is edited in the theme editor. */
  document.addEventListener('shopify:section:load', start);
})();
